import { useTheme } from "../../Theme";
import { jsx as _jsx } from "react/jsx-runtime";
export function useGetIcon(type) {
  var _useTheme = useTheme(),
      _useTheme$theme = _useTheme.theme,
      _useTheme$theme$icons = _useTheme$theme.icons,
      Info = _useTheme$theme$icons.info,
      Warning = _useTheme$theme$icons.warning,
      Error = _useTheme$theme$icons.error,
      Success = _useTheme$theme$icons.success,
      Loader = _useTheme$theme.loader;

  if (!type) return undefined;

  switch (type) {
    case "info":
      return /*#__PURE__*/_jsx(Info, {});

    case "warning":
      return /*#__PURE__*/_jsx(Warning, {});

    case "error":
      return /*#__PURE__*/_jsx(Error, {});

    case "success":
      return /*#__PURE__*/_jsx(Success, {});

    case "loading":
      return /*#__PURE__*/_jsx(Loader, {});
  }
}